<template>
  <ul class="nav nav-tabs" :class="[directionClass, alignClass]">
    <slot></slot>
  </ul>
</template>

<script>
import { TabEventBus } from './EventBus.js'

export default {
  name: 'TabsHorizontal',
  props: {
    vertical: { type: Boolean },
    right: { type: Boolean },
    bottom: { type: Boolean },
    target: { type: String, required: true }
  },
  provide () {
    return {
      elProp: this.elProp
    }
  },
  data () {
    return {
      elProp: {
        vertical: this.vertical,
        activeTab: null
      }
    }
  },
  computed: {
    directionClass () {
      return {
        tabs__vertical: this.vertical
      }
    },
    alignClass () {
      return {
        tabs__right: this.right,
        tabs__bottom: this.bottom
      }
    }
  },
  mounted () {
    if (this.$children.length > 0) {
      this.$children[0].isActive = true
    }
  },
  methods: {
    deactiveOtherTabs (selectedTab) {
      this.$children
        .filter(tab => tab !== selectedTab)
        .forEach(tab => {
          tab.isActive = false
        })
    }
  },
  watch: {
    'elProp.activeTab': {
      handler (selectedTab) {
        this.deactiveOtherTabs(selectedTab)
        TabEventBus.$emit('tabchange', {
          target: this.target,
          index: this.$children.indexOf(selectedTab)
        })
      }
    }
  }
}
</script>
